export const shouldHideBogotaSpecialCampaignPaymentAlert = (
  inSummary: boolean | undefined,
  isBogotaSpecialCampaign: boolean,
  hasNegotiation: boolean,
) => inSummary && isBogotaSpecialCampaign && !hasNegotiation;
